import { render, staticRenderFns } from "./ArchiveDetailDrawer.vue?vue&type=template&id=03db9205&scoped=true"
import script from "./ArchiveDetailDrawer.vue?vue&type=script&lang=js"
export * from "./ArchiveDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./ArchiveDetailDrawer.vue?vue&type=style&index=0&id=03db9205&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03db9205",
  null
  
)

export default component.exports